var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"short-video-recom"},[_c('short-video-play',{ref:"videoPlayer",attrs:{"section":'allCharacters'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }